import { writeGppString } from "./cookies";
import { log } from "./debug";

export type GppApi = (cmd: string, cb: (data: unknown, success: boolean) => void, param?: unknown) => void;

declare global {
  interface Window { __gpp?: GppApi; }
}

let optedOut = false;

function currentString() {
  return `GPP~usnat_${optedOut ? "1" : "0"}`;
}

export function initGpp(optOut = false, cmpId = 524) {
  optedOut = optOut;
  const gpc = (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl;
  if (gpc) optedOut = true;

  const ping = () => ({
    gppVersion: "1.1",
    cmpStatus: "loaded",
    cmpDisplayStatus: "hidden",
    signalStatus: "ready",
    supportedAPIs: ["usnat"],
    cmpId,
    sectionList: [7],
    applicableSections: [7],
    gppString: currentString()
  });

  window.__gpp = (cmd, cb, param) => {
    try {
      if (cmd === "ping") return cb(ping(), true);
      if (cmd === "getGPPData") return cb({ pingData: ping(), gppString: currentString(), applicableSections: [7] }, true);
      if (cmd === "hasSection") return cb(param === "usnat" || param === 7, true);
      if (cmd === "getSection") return cb({ SaleOptOut: optedOut ? 1 : 2, SharingOptOut: optedOut ? 1 : 2 }, true);
      if (cmd === "addEventListener") return cb({ eventName: "listenerRegistered", listenerId: 1, data: true }, true);
      return cb(null, false);
    } catch { cb(null, false); }
  };
  writeGppString(currentString());
  log("gpp", `__gpp installed (usnat), GPC ${gpc ? "on → opt-out" : "off"}`, { gppString: currentString() });
}

export function setUsOptOut(value: boolean) {
  optedOut = value || !!(navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl;
  writeGppString(currentString());
  log("gpp", `US opt-out ${optedOut ? "set" : "cleared"}`, { gppString: currentString() });
  window.dispatchEvent(new CustomEvent("cmp:gpp", { detail: { optedOut } }));
}

export function isOptedOut() { return optedOut; }
export function gppString() { return currentString(); }
